import React, { useState, useEffect } from "react"
import { Row, Col } from "reactstrap"
import { getCurrentUser, getPermission } from "../../../helpers/Utils.js"
import axios from "axios"
import Paginations from "../../Pagination/index.jsx"
import Loader from "../../Loader/loader.js"
import MultipleChoice from "../../Filter/MultipleChoice/index.jsx"
import InputFilter from "../../Filter/SearchFilter/index.jsx"
import SweetAlert from "react-bootstrap-sweetalert"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import FetcheModal from "../Fetch-From-Api/FetcheModal.js"
import FetchEList from "../Fetch-From-Api/fetch-elist.js"

const FetchStaff = () => {
  const [modal_standard1, setmodal_standard1] = useState(false)
  const [allFetch1, setAllFetch1] = useState([])
  const [error4, setError4] = useState("")
  const [loader4, setLoader4] = useState(<Loader />)
  const [allPages1, setAllPages1] = useState([])
  const [counter4, setCounter4] = useState("")
  const [allSource4, setAllSource4] = useState([])
  const [name_filter4, setname_filter4] = useState(false)
  const [message_filter4, setmessage_filter4] = useState(false)
  const [leadsource_filter4, setleadsource_filter4] = useState(false)
  const [status3_filter4, setstatus3_filter4] = useState(false)
  const [searchedCount4, setSearchedCount4] = useState("")
  const [blur4, setBlur4] = useState(false)
  const [leadsSelectedIds4, setLeadsSelectedIds4] = useState([])
  const [success_dlg4, setsuccess_dlg4] = useState(false)
  const [dynamic_title4, setdynamic_title4] = useState("")
  const [dynamic_description4, setdynamic_description4] = useState("")
  const [confirm_alert1, setconfirm_alert1] = useState(false)

  const getAllFetch1 = () => {
    setLoader4(<Loader />)
    setAllFetch1([])
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/fetch-from-email?type=email&per_page=${
          localStorage.getItem("PerPage") !== null
            ? localStorage.getItem("PerPage")
            : ""
        }`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setLoader4("")
          setError4(res.data.message)
          setCounter4(res.data.data.from)
          setAllFetch1(res.data.data.data)
          setAllPages1(res.data.data)
        } else {
          setLoader4("")
          setError4(res.data.message)
        }
      })
  }

  const paginate1 = e => {
    setAllFetch1([])
    setAllPages1([])
    setCounter4("")
    setLoader4(<Loader />)
    axios
      .get(
        `${e}&type=email&latest_leads_only=${
          localStorage.getItem("leadStatus3") !== null
            ? localStorage.getItem("leadStatus3")
            : ""
        }
            &host=${
              localStorage.getItem("leadName") !== null
                ? localStorage.getItem("leadName")
                : ""
            }
            &lead_source_id=${
              localStorage.getItem("leadSource") !== null
                ? localStorage.getItem("leadSource")
                : ""
            }
            &platform=${
              localStorage.getItem("leadMessage") !== null
                ? localStorage.getItem("leadMessage")
                : ""
            }`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setLoader4("")
          setCounter4(res.data.data.from)
          setAllPages1(res.data.data)
          setAllFetch1(res.data.data.data)
        } else {
          setError4(res.data.message)
          setLoader4("")
        }
      })
  }

  const getSearchedLeads1 = (e, type) => {
    setError4("")
    if (type == "name") {
      localStorage.setItem("leadName", e)
    }
    if (type == "leadsource") {
      localStorage.setItem("leadSource", e)
    }
    if (type == "status3") {
      localStorage.setItem("leadStatus3", e)
    }
    if (type == "message") {
      localStorage.setItem("leadMessage", e)
    }
    setSearchedCount4("")
    setAllFetch1([])
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/fetch-from-email?type=email&latest_leads_only=${
          localStorage.getItem("leadStatus3") !== null
            ? localStorage.getItem("leadStatus3")
            : ""
        }
         &host=${
           localStorage.getItem("leadName") !== null
             ? localStorage.getItem("leadName")
             : ""
         }
         &lead_source_id=${
           localStorage.getItem("leadSource") !== null
             ? localStorage.getItem("leadSource")
             : ""
         }
         &platform=${
           localStorage.getItem("leadMessage") !== null
             ? localStorage.getItem("leadMessage")
             : ""
         }
         &per_page=${
           localStorage.getItem("PerPage") !== null
             ? localStorage.getItem("PerPage")
             : ""
         }
         `,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setLoader4("")
          setCounter4(res.data.data.from)
          setAllFetch1(res.data.data.data)
          setAllPages1(res.data.data)
          setSearchedCount4(res.data.data.total)
          setname_filter4(false)
          setleadsource_filter4(false)
          setmessage_filter4(false)
          setstatus3_filter4(false)
        } else {
          setError4(res.data.message)
        }
      })
  }

  const getAllSource1 = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/lead/source?per_page=5000`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setAllSource4(res.data.data.data)
        } else {
        }
      })
  }

  const selectAllCheck1 = check => {
    if (check.checked) {
      var ele = document.getElementsByName("chk")
      for (var i = 0; i < ele.length; i++) {
        if (ele[i].type == "checkbox") {
          ele[i].checked = true
          leadsSelectedIds4.push(parseInt(ele[i].value))
        }
      }
    } else {
      var ele = document.getElementsByName("chk")
      for (var i = 0; i < ele.length; i++) {
        if (ele[i].type == "checkbox") {
          ele[i].checked = false
          var array = leadsSelectedIds4
          var index = array.indexOf(parseInt(ele[i].value))
          if (index !== -1) {
            array.splice(index, 1)
          }
        }
      }
    }
    if (leadsSelectedIds4.length === 0) {
      setBlur4(false)
    } else {
      setBlur4(true)
    }
  }

  const exportLead1 = () => {
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/fetch-from-email-export`,
        {
          ids: leadsSelectedIds4,
          type: "email",
        },

        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setLeadsSelectedIds4([])
          window.location.href = res.data.file_url
          setTimeout(() => {
            dFileName1(res.data.file_name)
          }, 5000)
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
  }

  const dFileName1 = e => {
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/delete-fetch-from-email-file`,
        {
          file_name: e,
        },
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
        } else {
        }
      })
  }

  const deleteLeads1 = () => {
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/multiple-fetch-email-deleted`,
        {
          ids: leadsSelectedIds4,
          type: "email",
        },
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setLeadsSelectedIds4([])
          getAllFetch1()
          setdynamic_description4(res.data.message)
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
  }

  useEffect(() => {
    getAllFetch1()
    getAllSource1()
  }, [])

  return (
    <>
      {modal_standard1 ? (
        <FetcheModal
          modal_standard1={modal_standard1}
          setmodal_standard1={setmodal_standard1}
          getAllFetch1={getAllFetch1}
        />
      ) : (
        ""
      )}
      {confirm_alert1 ? (
        <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmButtonText="Yes, delete it!"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            setconfirm_alert1(false)
            setsuccess_dlg4(true)
            deleteLeads1()
            setdynamic_title4("Deleted")
            setdynamic_description4("Your file has been deleted.")
          }}
          onCancel={() => setconfirm_alert1(false)}
        >
          <span className="text-danger">You won't be able to revert this!</span>
        </SweetAlert>
      ) : null}
      <div className="page-title-box">
        <Row className="align-items-center">
          <Col md={6}>
            <h6 className="page-title">Fetch From Email</h6>
          </Col>
          <Col md={6}>
            <h6 className="page-title float-end">
              {blur4 ? (
                <div className="btn-group me-2">
                  <button type="button" className="btn btn-primary">
                    Action
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa fa-caret-down"></i>
                  </button>
                  <ul className="dropdown-menu">
                    <li>
                      <span
                        className="dropdown-item"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setconfirm_alert1(true)
                        }}
                      >
                        Batch delete
                      </span>
                    </li>
                  </ul>
                </div>
              ) : (
                <div className="btn-group me-2">
                  <button type="button" className="btn btn-primary" disabled>
                    Action
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                    disabled
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa fa-caret-down"></i>
                  </button>
                  <ul className="dropdown-menu">
                    <li>
                      <span
                        className="dropdown-item"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setconfirm_alert1(true)
                        }}
                      >
                        Batch delete
                      </span>
                    </li>
                  </ul>
                </div>
              )}
              {getPermission() &&
              getPermission().lead_export.lead_export.view.is_checked ===
                "yes" ? (
                <button
                  className="btn btn-primary submit__button me-2"
                  onClick={() => {
                    exportLead1()
                  }}
                >
                  Export
                </button>
              ) : (
                ""
              )}
              <button
                className="btn btn-success"
                type="button"
                onClick={() => {
                  setmodal_standard1(true)
                }}
              >
                Add New
              </button>
            </h6>
          </Col>
        </Row>
        <Row>
          <Col>
            {searchedCount4 !== "" ? (
              <h6 className="">
                Searched Results
                <span> ({searchedCount4})</span>
              </h6>
            ) : (
              ""
            )}
          </Col>
        </Row>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="lead_table table table-sm table-bordered table-responsive">
            <table style={{ width: "100%" }}>
              <tbody>
                <tr className="static-header">
                  <th>
                    <input
                      onClick={e => selectAllCheck1(e.target)}
                      className="p-0 d-inline-block"
                      type="checkbox"
                    />
                  </th>
                  <th>#</th>
                  <th>
                    <div
                      className="position-relative"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Host
                      {name_filter4 ? (
                        <>
                          <span
                            style={{ cursor: "pointer", color: "orange" }}
                            onClick={() => setname_filter4(false)}
                          >
                            <i className="fa fa-times fa-lg ms-2"></i>
                          </span>
                        </>
                      ) : (
                        <>
                          {localStorage.getItem("leadName") == "" ? (
                            <span
                              className=""
                              style={{ cursor: "pointer" }}
                              onClick={() => setname_filter4(true)}
                            >
                              <i className="fa fa-filter ms-2"></i>
                            </span>
                          ) : (
                            <span
                              className=""
                              style={{ cursor: "pointer", color: "orange" }}
                              onClick={() => setname_filter4(true)}
                            >
                              <i className="fa fa-filter ms-2"></i>
                            </span>
                          )}
                        </>
                      )}
                      <InputFilter
                        name_filter={name_filter4}
                        setname_filter={setname_filter4}
                        getSearchedLeads={getSearchedLeads1}
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="position-relative"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Platform
                      {message_filter4 ? (
                        <>
                          <span
                            style={{ cursor: "pointer", color: "orange" }}
                            onClick={() => setmessage_filter4(false)}
                          >
                            <i className="fa fa-times fa-lg ms-2"></i>
                          </span>
                        </>
                      ) : (
                        <>
                          {localStorage.getItem("leadMessage") == "" ? (
                            <span
                              className=""
                              style={{ cursor: "pointer" }}
                              onClick={() => setmessage_filter4(true)}
                            >
                              <i className="fa fa-filter ms-2"></i>
                            </span>
                          ) : (
                            <span
                              className=""
                              style={{ cursor: "pointer", color: "orange" }}
                              onClick={() => setmessage_filter4(true)}
                            >
                              <i className="fa fa-filter ms-2"></i>
                            </span>
                          )}
                        </>
                      )}
                      <InputFilter
                        message_filter={message_filter4}
                        setmessage_filter={setmessage_filter4}
                        getSearchedLeads={getSearchedLeads1}
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="position-relative"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Lead Source
                      {leadsource_filter4 ? (
                        <>
                          <span
                            style={{ cursor: "pointer", color: "orange" }}
                            onClick={() => setleadsource_filter4(false)}
                          >
                            <i className="fa fa-times fa-lg ms-2"></i>
                          </span>
                        </>
                      ) : (
                        <>
                          {localStorage.getItem("leadSource") == "" ? (
                            <span
                              className=""
                              style={{ cursor: "pointer" }}
                              onClick={() => setleadsource_filter4(true)}
                            >
                              <i className="fa fa-filter ms-2"></i>
                            </span>
                          ) : (
                            <span
                              className=""
                              style={{ cursor: "pointer", color: "orange" }}
                              onClick={() => setleadsource_filter4(true)}
                            >
                              <i className="fa fa-filter ms-2"></i>
                            </span>
                          )}
                        </>
                      )}
                      <MultipleChoice
                        leadsource_filter={leadsource_filter4}
                        setleadsource_filter={setleadsource_filter4}
                        data={allSource4}
                        getSearchedLeads={getSearchedLeads1}
                      />
                    </div>
                  </th>
                  <th>Auto Assign To</th>
                  <th>
                    <div
                      className="position-relative"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Latest Lead Only
                      {status3_filter4 ? (
                        <>
                          <span
                            className=""
                            style={{ cursor: "pointer", color: "orange" }}
                            onClick={() => setstatus3_filter4(false)}
                          >
                            <i className="fa fa-times fa-lg ms-2"></i>
                          </span>
                        </>
                      ) : (
                        <>
                          {localStorage.getItem("leadStatus3") == "" ? (
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => setstatus3_filter4(true)}
                            >
                              <i className="fa fa-filter ms-2"></i>
                            </span>
                          ) : (
                            <span
                              style={{ cursor: "pointer", color: "orange" }}
                              onClick={() => setstatus3_filter4(true)}
                            >
                              <i className="fa fa-filter ms-2"></i>
                            </span>
                          )}
                        </>
                      )}
                      <MultipleChoice
                        status3_filter={status3_filter4}
                        setstatus3_filter={setstatus3_filter4}
                        getSearchedLeads={getSearchedLeads1}
                      />
                    </div>
                  </th>
                  <th>Action</th>
                </tr>
                {allFetch1 &&
                  allFetch1.map((item, obj) => (
                    <FetchEList
                      key={obj}
                      data={item}
                      setBlur={setBlur4}
                      setLeadsSelectedIds={setLeadsSelectedIds4}
                      leadsSelectedIds={leadsSelectedIds4}
                      i={obj}
                      counter={counter4}
                    />
                  ))}
              </tbody>
            </table>
            {error4 ? (
              <span className="text-danger mt-3 d-table m-auto" role="alert">
                {error4}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      {loader4}
      {allPages1 !== [] ? (
        <Paginations
          data={allPages1}
          paginate={paginate1}
          perPage={getAllFetch1}
        />
      ) : (
        ""
      )}
    </>
  )
}
export default FetchStaff
